import Api from './rest/SpecCustomerApi';

export default new Api();
